module.exports = __webpack_public_path__ + "img/icon_benefit_06_w.d5749e70.svg";